'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    initSavePurchaseConfirmNumber();
    loadLocaleOnTabClick();

    function loadLocaleOnTabClick() {
        var cdmItems = document.querySelectorAll('.menu-item-last');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(cdmItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.loadLocaleRegistered) continue;

                item.addEventListener('click', function () {
                    (0, _localize.loadLocale)().then(function () {});
                });
                item.loadLocaleRegistered = true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    function initSavePurchaseConfirmNumber() {
        var purchaseConfirmNumber = document.getElementById('purchaseConfirmNumber');
        var savePcnButon = document.getElementById('savePurchaseConfirmNumberButton');

        if (!purchaseConfirmNumber || !savePcnButon || purchaseConfirmNumber.registered) return;
        purchaseConfirmNumber.registered = true;

        savePcnButon.addEventListener('click', function (event) {
            var xhr = new XMLHttpRequest();

            var reportId = purchaseConfirmNumber.dataset.reportId;
            var value = purchaseConfirmNumber.value;
            var url = '/Commission/SavePurchaseConfirmNumber/?reportId=' + reportId + '&purchaseConfirmNumber=' + value;
            xhr.open('POST', url);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('X-XSRF-TOKEN', _cookie2.default.getCookie('XSRF-TOKEN'));
            xhr.onreadystatechange = function () {
                onPurchaseConfirmNumberSaved(xhr, purchaseConfirmNumber);
            };
            xhr.send();
        });
    }

    function onPurchaseConfirmNumberSaved(xhr, purchaseConfirmNumber) {
        if (!xhr || xhr.readyState !== 4) return;

        var returnObject = JSON.parse(xhr.response);
        if (returnObject.success) {
            var result = returnObject.result;
            var errorMessage = result.detailMessage;

            if (result.statusMessage === 'warning') {
                purchaseConfirmNumber.value = purchaseConfirmNumber.dataset.originalNumber;
            } else if (result.statusMessage === 'error') {
                purchaseConfirmNumber.value = purchaseConfirmNumber.dataset.originalNumber;
                console.error('Server Error: ' + result.detailMessage);
                errorMessage = Resx.App.ContestResponseStatusError;
            }

            sweetAlert({
                text: errorMessage,
                type: result.statusMessage,
                title: Resx.App.PurchaseConfirmNumber,
                showCancelButton: false,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: Resx.Common.Confirm
            });
        }
    }
};

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/miscellaneous.js
// module id = 942
// module chunks = 0